<template>

  <div class="leftSide">
    <div class="sfLogoWrap">
      <router-link to="/"></router-link>
    </div>
    <nav class="sfNavigation">
      <ul>
        <router-link tag="li" :to="{path : '/sf/sunnyfactory'}">SUNNY FACTORY</router-link>
        <router-link tag="li" :to="{path : '/sf/portfolio'}">PORTFOLIO</router-link>
        <router-link tag="li" :to="{path : '/sf/contactus'}">CONTACT US</router-link>
      </ul>
    </nav>
    <div class="snsAndCopyRight">
      <div>
        <div class="snsWrap">
          <button class="shareplatBtn" @click="snsLocation('shareplat')"></button>
          <button class="instagramBtn" @click="snsLocation('instagram')"></button>
          <button class="facebookBtn" @click="snsLocation('facebook')"></button>
          <button class="twitterBtn" @click="snsLocation('twitter')"></button>
        </div>
        <div class="copyRightWrap">
          <strong class="copyRight">
            Copyright © SunnyFactory<br/>
            [factorysunny.com]<br/>
            All Rights Reserved.
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      components: {

      },
      name: "LeftSide" ,
        methods : {
          snsLocation (type)  {
            const locationUrl = {
              instagram : 'https://www.instagram.com/jihoonlee1980/' ,
              facebook : 'https://www.facebook.com/SunnyFactory-149706582359643/' ,
              twitter : 'https://twitter.com/sunny9224' ,
              shareplat : 'https://shareplatform.net' ,
            }
            window.open(
              locationUrl[type],
              '_blank'
            );
          },
        }
    }
</script>

<style scoped lang="scss">
  @import '@/styles/Global.scss';

  .leftSide {
    width: 260px;
    background: #1a2d39;
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    @include respond-to('medium') {
      display: none;
    }
    .sfLogoWrap{
      width:100%;
      height:250px;
      background:url(https://d77k7si2heyyr.cloudfront.net/images/icons/sf-logo.png) center no-repeat;
      /*cursor:pointer;*/
      >a {
        display:flex;
        width:100%;
        height:100%;
      }
    }
    .sfNavigation{
      width:75%;
      margin:0 auto;
      >ul{
        >li{
          list-style: none;
          margin:1rem 0;
          font-size:1.3rem;
          color:#fff;
          cursor:pointer;
        }
      }
    }
    .snsAndCopyRight{
      width:100%;
      flex:1;
      display: flex;
      align-items: flex-end;
      >div{
        width:100%;
        height:250px;
        .snsWrap {
          width:60%;
          margin:2rem auto;
          display: flex;
          justify-content: space-around;
          >button {
            width:30px;
            height:30px;
            border:none;
            cursor:pointer;
          }
          .shareplatBtn {
            background: url(https://d77k7si2heyyr.cloudfront.net/images/icons/shareplat-loaction.icon.png) center no-repeat;
          }
          .instagramBtn {
            background:url(https://d77k7si2heyyr.cloudfront.net/images/icons/instagram.png) center no-repeat;
          }
          .facebookBtn {
            background:url(https://d77k7si2heyyr.cloudfront.net/images/icons/facebook.png) center no-repeat;
          }
          .twitterBtn {
            background:url(https://d77k7si2heyyr.cloudfront.net/images/icons/twitter.png) center no-repeat;
          }
        }
        .copyRightWrap {
          width:75%;
          margin:0 auto;
          >strong.copyRight {
            color:#fff;
            font-weight: 200;
            font-size:1rem;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/layouts/LeftSide.vue